function CurTsZ(){
  let ull = new URL(window.location.href);
  let prms = new URLSearchParams(ull.search);
  var varia_d = null;
  /*幅のセレクト値を回収*/
  var ctn_w_para = "";
  var ctn_A_w = document.getElementsByClassName("Curtain_W_Int")[0].value;
  var ctn_B_w_arr = document.getElementsByClassName("Curtain_W_Dec");
  var ctn_w = ctn_A_w;
  /*if(ctn_B_w_arr.length > 0){var ctn_w = ctn_w + ".";};*//*-- 小数点以下切り捨てのため、小数点不要 --*/
  for(var a = 0;a < ctn_B_w_arr.length; a++){
    /*var ctn_w = ctn_w + ctn_B_w_arr[a].value;*//*-- 小数点以下切り捨てのため、不要 --*/
    var ctn_w_para = ctn_w_para + "_" + ctn_B_w_arr[a].value;/*パラメータ用に別途格納*/
  };
  var ctn_w_para = ctn_A_w + ctn_w_para;
  /*幅のセレクト値を回収*/
  
  /*高のセレクト値を回収*/
  var ctn_h_para = "";
  var ctn_A_h = document.getElementsByClassName("Curtain_H_Int")[0].value;
  var ctn_B_h_arr = document.getElementsByClassName("Curtain_H_Dec");
  var ctn_h = ctn_A_h;
  /*if(ctn_B_h_arr.length > 0){var ctn_h = ctn_h + ".";};*//*-- 小数点以下切り捨てのため、不要 --*/
  for(var a = 0;a < ctn_B_h_arr.length; a++){
    /*var ctn_h = ctn_h + ctn_B_h_arr[a].value;/*-- 小数点以下切り捨てのため、不要 --*/
    var ctn_h_para = ctn_h_para + "_" + ctn_B_h_arr[a].value;/*パラメータ用に別途格納*/
  };
  var ctn_h_para = ctn_A_h + ctn_h_para;
  /*高のセレクト値を回収*/

  /*各バリエーションの最小・最大を取得*/
  var selid = document.getElementById("Curtain_Size_checkNumb-Selecid").getAttribute("data-checkNumbSelecid");
  var selop = document.getElementById(selid).getElementsByTagName("option");
  for(var a = 0;a < selop.length; a++){
    var selop_v = selop[a].value;
    var selop_v_sp1 = selop_v.split("/[");
    /*console.log(selop_v_sp1[1]);*/
    var selop_v_sp2 = selop_v_sp1[1].split("]");
    var selop_v_sp3 = selop_v_sp2[0].replace("W","");
    var selop_v_sp3 = selop_v_sp3.replace("H","");
    
    var opt_v = selop_v_sp3.split("/");
    var opt_v_w = opt_v[0].split("-");
    var opt_v_h = opt_v[1].split("-");

    /*小数点付きのままだと性格な計算ができないため、桁数を確認して整数に修正（小数点不要となったため、こちらも不要　今後小数点計算用に残しておく）*/
    var opt_w_min = opt_v_w[0];var opt_w_max = opt_v_w[1];var ctn_w_chk = Number(ctn_w);
    if(ctn_B_w_arr.length > 0){
      var w_ml = 1;
      for(var b = 0;b < ctn_B_w_arr.length; b++){var w_ml = w_ml * 10;};
      var opt_w_min = opt_v_w[0] * w_ml;var opt_w_max = opt_v_w[1] * w_ml;var ctn_w_chk = ctn_w_chk * w_ml;
    };
    var opt_h_min = opt_v_h[0];var opt_h_max = opt_v_h[1];var ctn_h_chk = Number(ctn_h);
    if(ctn_B_h_arr.length > 0){
      var h_ml = 1;
      for(var b = 0;b < ctn_B_h_arr.length; b++){var h_ml = h_ml * 10;};
      var opt_h_min = opt_v_h[0] * h_ml;var opt_h_max = opt_v_h[1] * h_ml;var ctn_h_chk = ctn_h_chk * h_ml;
    };
    /*小数点付きのままだと性格な計算ができないため、桁数を確認して整数に修正*/
    /*各バリエーションの最小・最大の間にセレクトの値を代入し、条件を満たしたバリエーション値を回収*/
    if(opt_w_min <= ctn_w_chk && ctn_w_chk <= opt_w_max && opt_h_min <= ctn_h_chk && ctn_h_chk <= opt_h_max){
      var valist = document.getElementsByClassName("Curtain_variat_for_lists");
      for(var c = 0;c < valist.length; c++){
        var varia = valist[c].getAttribute("data-variatitle");
        if(selop_v == varia){
          var varia_d = valist[c].getAttribute("data-variatfor");   
          /*console.log(opt_w_min + "<=" + ctn_w_chk  + "<=" + opt_w_max + "&&" + opt_h_min + "<=" + ctn_h_chk + "<=" + opt_h_max);*/
          /*var ddd = prms.get("variant");*/
          /*console.log(ddd + "*");*/
          /*document.getElementById(selid).selectedIndex = a;*/
        };
      };
    };
  };
  if(varia_d != null){
    var clr_cd = document.getElementById("crtn-clr_slct").value;
    var cin_cd = document.getElementById("crtn-chain_slct").value;
    prms.set("variant",varia_d);
    prms.set("curtn_sz",ctn_w_para + "x" + ctn_h_para + "x" + clr_cd + "x" + cin_cd);
    window.location.search = prms.toString();
  }else{
    document.getElementById("ctr-vlCH_alert").style = "display:block;";
  };
};

function CurTclR(){
  var clrcd = "#" + document.getElementById("crtn-clr_slct").value;
  document.getElementById("crtn-clr_box").style = "background-color:" + clrcd + ";";
};

document.addEventListener('DOMContentLoaded', function(){
  let ull = new URL(window.location.href);
  let prms = new URLSearchParams(ull.search);
  var gprm = prms.get("curtn_sz");
  var Wslct = document.getElementsByClassName("Curtain-W_field_sel")[0].getElementsByTagName("select");
  var Hslct = document.getElementsByClassName("Curtain-H_field_sel")[0].getElementsByTagName("select");
  var Cslct = document.getElementById("crtn-clr_slct").getElementsByTagName("option");
  var Kslct = document.getElementById("crtn-chain_slct").getElementsByTagName("option");
  if(gprm != null){
    var crtn = gprm.split("x");
    var crtn_w = crtn[0].split("_");
    var Winpt = crtn_w[0] + ".";
    for(var e = 0;e < crtn_w.length; e++){
      var Wopt = Wslct[e].getElementsByTagName("option");
      for(var f = 0;f < Wopt.length; f++){
        if(crtn_w[e] == Wopt[f].value){
          Wslct[e].selectedIndex = f;if(e > 0){var Winpt = Winpt + Wopt[f].value;};
          var f = Wopt.length;
        };
      };
    };
    var crtn_h = crtn[1].split("_");
    var Hinpt = crtn_h[0] + ".";
    for(var e = 0;e < crtn_h.length; e++){
      var Hopt = Hslct[e].getElementsByTagName("option");
      for(var f = 0;f < Hopt.length; f++){
        if(crtn_h[e] == Hopt[f].value){
          Hslct[e].selectedIndex = f;if(e > 0){var Hinpt = Hinpt + Hopt[f].value;};
          var f = Hopt.length;
        };
      };
    };
    var clr_cd = crtn[2];
    for(var e = 0;e < Cslct.length; e++){
      var Copt = Cslct[e].value;
      if(clr_cd == Copt){
        document.getElementById("crtn-clr_slct").selectedIndex = e;document.getElementById("crtn-clr_box").style = "background-color:" + "#" + clr_cd + ";";
        var Cinpt = document.getElementById("crtn-clr_slct").getElementsByTagName("option")[e].getAttribute("data-clr");
      };
    };
    var cin_cd = crtn[3];
    for(var e = 0;e < Kslct.length; e++){
      var Kopt = Kslct[e].value;
      if(cin_cd == Kopt){
        document.getElementById("crtn-chain_slct").selectedIndex = e;
        var Kinpt = document.getElementById("crtn-chain_slct").getElementsByTagName("option")[e].getAttribute("data-cin");
      };
    };
    document.getElementById("crtn-input_A_w").textContent = Winpt + " cm";
    document.getElementById("crtn-input_A_h").textContent = Hinpt + " cm";
    document.getElementById("crtn-input_A_c").textContent = Cinpt.split(" / ")[0];
    document.getElementById("crtn-input_A_k").textContent = Kinpt;
    document.getElementById("crtn-w-size").value = Winpt;
    document.getElementById("crtn-h-size").value = Hinpt;
    document.getElementById("crtn-c-size").value = Cinpt;
    document.getElementById("crtn-k-size").value = Kinpt;
    window.location.hash = "#crt-jmp";
  };
});